module.exports = __webpack_public_path__ + "img/104020.08eb1de0.png";